<template>
  <div class="jytp-con">
    <div class="list">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="getJytp"
      >
        <div
          v-for="item in jytpData"
          :key="item.id"
          @click="goTp(item.code)"
          class="li"
        >
          <span>{{ item.name }}</span>
          <span>{{ item.code }}</span>
          <span class="star">
            <i
              v-for="(star, index2) in 3"
              :key="index2"
              :class="{
                active: index2 < Math.abs(item.star),
                yellow: item.star < 0,
              }"
            ></i>
          </span>
          <span @click.stop="item.muser && goHuiXin(item.muser)">
            {{ item.mname ? item.mname : "" }}
          </span>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["stockCode", "handleDataLoadedNum"],
    data() {
      return {
        loading: false,
        finished: false,
        token: "",
        pageNum: 1,
        titleList: ["股票名称", "股票代码", "框架星级", "研究员讲解"],
        jytpData: [],
        isjytpResult: false,
        navTop: 0,
        themeStyleVs: "",
      };
    },
    mounted() {
      this.token = this.$route.query.token;
      this.themeStyleVs = this.$route.query.themeStyleVs;
    },
    // watch: {
    //   stockCode () {
    //     this.getJytp()
    //   }
    // },
    methods: {
      // 获取经营图谱
      getJytp() {
        let _this = this;
        var postParam = {
          qid: new Date().getTime(),
          pageNum: this.pageNum,
          param: {
            stock: this.stockCode,
          },
        };
        _this
          .$http({
            method: "post",
            url:
              window.config.research_server +
              "/research-framework-server/rf/pld/page",
            data: postParam,
            headers: {
              token: _this.token,
            },
          })
          .then((res) => {
            // 加载状态结束
            _this.loading = false;
            if (res.data.code == 0) {
              _this.jytpData.push(...res.data.data.data);
              // 数据全部加载完成
              if (res.data.data.data.length < 20) {
                _this.finished = true;
              } else {
                _this.pageNum += 1;
              }
            } else {
              _this.finished = true;
            }

            if (_this.handleDataLoadedNum == 6) {
              _this.$emit("data-loaded"); // 发出事件通知父组件数据已经加载完毕
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      goHuiXin(user) {
        this.toUrl(`dzh_browser_url&goto=0&screen=234&dzh_account=${user}&tim_identifer=${user}&action=1`);
      },
      goTp(code) {
        var url =
          window.config.qytp_link +
          `/yjtp/yzty.html?code=${code}&DZHSPECIAL=285&themeStyleVs=${this.themeStyleVs}`;
        this.toUrl(url);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .jytp-con {
    height: calc(100vh - 1.7rem);
    overflow-y: auto;
    padding-bottom: 0.2rem;
    .fixed {
      position: fixed;
      left: 0;
      top: 0rem;
      right: 0;
      background: #fff;
      z-index: 1;
    }
    .list {
      padding: 0 0.08rem;
      .li {
        display: flex;
        height: 0.44rem;
        align-items: center;
        padding: 0 0.24rem;
        line-height: 1;
        &:nth-child(even) {
          background: #fafafc;
        }
        span {
          width: 25%;
          text-align: center;
          font-size: 0.14rem;
          color: #555;
          &:nth-child(1) {
            text-align: left;
            color: #286df7;
            width: 24%;
          }
          &:nth-child(2) {
            flex: 1;
          }
          &:nth-child(3) {
            padding-left: 0.1rem;
          }
          &:nth-child(4) {
            color: #286df7;
            text-align: left;
            padding-left: 0.24rem;
          }
        }
        .star {
          justify-content: center;
        }
      }
    }
  }
  .blackTheme {
    .jytp-con {
      .list {
        .li {
          &:nth-child(even) {
            background: #1b1d29;
          }
          span {
            color: #aab9d1;
            &:nth-child(1) {
              color: #3b85fe;
            }
            &:nth-child(4) {
              color: #3b85fe;
            }
          }
        }
      }
    }
  }
</style>
